import React from 'react';

import H1 from './headings/H1';
import HeroH1 from './headings/HeroH1';
import H2 from './headings/H2';
import H3 from './headings/H3';
import H4 from './headings/H4';
import H5 from './headings/H5';
import H6 from './headings/H6';
import H7 from './headings/H7';
import H8 from './headings/H8';
import Body1 from './body-fonts/Body1';
import Body2 from './body-fonts/Body2';
import Body3 from './body-fonts/Body3';
import Body4 from './body-fonts/Body4';
import Body5 from './body-fonts/Body5';
import Body6 from './body-fonts/Body6';
import AllCaps from './body-fonts/AllCaps';
import LargeBody from './body-fonts/LargeBody';

//  allows you to select component h1-h8, or body1-body5
export default ({ children, ...props }) => {
	switch (props.component?.toLowerCase()) {
		case 'h1':
		case 'heading1':
			return <H1 {...props}>{children}</H1>;
		case 'hero':
			return <HeroH1 {...props}>{children}</HeroH1>;
		case 'h2':
		case 'heading2':
			return <H2 {...props}>{children}</H2>;
		case 'h3':
		case 'heading3':
			return <H3 {...props}>{children}</H3>;
		case 'h4':
		case 'heading4':
			return <H4 {...props}>{children}</H4>;
		case 'h5':
		case 'heading5':
			return <H5 {...props}>{children}</H5>;
		case 'h6':
		case 'heading6':
			return <H6 {...props}>{children}</H6>;
		case 'h7':
		case 'heading7':
			return <H7 {...props}>{children}</H7>;
		case 'h8':
		case 'heading8':
			return <H8 {...props}>{children}</H8>;
		case 'b1':
		case 'body1':
			return <Body1 {...props}>{children}</Body1>;
		case 'b2':
		case 'body2':
			return <Body2 {...props}>{children}</Body2>;
		case 'b3':
		case 'body3':
			return <Body3 {...props}>{children}</Body3>;
		case 'b4':
		case 'body4':
			return <Body4 {...props}>{children}</Body4>;
		case 'b5':
		case 'body5':
			return <Body5 {...props}>{children}</Body5>;
		case 'b6':
		case 'body6':
			return <Body6 {...props}>{children}</Body6>;
		case 'caps':
		case 'allCaps':
		case 'overline':
		case 'superText':
			return <AllCaps {...props}>{children}</AllCaps>;
		case 'quoteBody':
		case 'quotebody':
			return (
				<Body2
					{...props}
					css={{ lineHeight: '32px', fontFamily: 'ProximaNova-Regular' }}
				>
					{children}
				</Body2>
			);

		case 'quoteName':
		case 'quotename':
			return (
				<H7 {...props}>
					{
						// for title case:
						children?.replace(/\w\S*/g, function (txt) {
							return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
						})
					}
				</H7>
			);

		case 'quoteTitle':
		case 'quotetitle':
			return (
				<AllCaps {...props} css={{ fontFamily: 'ProximaNova-Regular' }}>
					{children}
				</AllCaps>
			);

		case 'largeBody':
			return <LargeBody {...props}>{children}</LargeBody>;

		default:
			return <Body5 {...props}>{children}</Body5>;
	}
};
